import React from "react";
import { clsx } from "clsx";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";

import { Locale } from "~types/wardenclyffe";
import { isLanguageCodeJa } from "~utils/i18n/isLanguageCodeJa";

import styles from "./ArticleDek.module.css";

interface ArticleDekProps {
    className?: string;
    dek?: string;
    languageCode?: Locale;
}

export const ArticleDek = ({
    className,
    dek,
    languageCode = Locale.En,
}: ArticleDekProps) => {
    if (!dek) {
        return null;
    }

    const isJa = isLanguageCodeJa(languageCode);

    return (
        <div
            className={clsx(className, {
                [styles.dekDefaultLocale]: !isJa,
                [typographyStyles.articleBody]: isJa,
            })}
            dangerouslySetInnerHTML={{ __html: dek }}
            data-component="dek"
        />
    );
};
